<template>
  <div class="form-collapse" style="margin-top:20px">
    <div class="info">
      <layui-form ref="storageForm" :rule="form_rule" :requestUniqueId="requestId" :showForm="true">
        <template slot-scope="{scope}">
          <div class="layui-form">
              <template>
                  <div class="layui-colla-item">
                    <h2 class="layui-colla-title">资料库基本信息</h2>
                    <div class="layui-colla-content layui-show">
                      <div class="layui-form-item-one">
                            <div class="layui-form-item">
                              <label class="layui-form-label">资料名称：</label>
                              <div class="layui-input-inline" style="width: 60%">
                                   <input
                                      type="text"
                                      v-model="scope.editRow.STORAGE_NAME"
                                      autocomplete="off"
                                      class="layui-input"
                                      name="STORAGE_NAME"
                                      placeholder="请输入资料名称"
                                    />
                              </div>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label">资料列表：</label>
                              <div class="layui-input-inline" style="width: 60%">
                                   <layui-listfileupload v-model="scope.editRow.STORAGE_FILES" targetEl=".siteForm" name="STORAGE_FILES">
                                    <template  slot-scope="{scope}">
                                            <div class="layui-upload">
                                                <button type="button" @click="scope.upload()" class="layui-upload-btn"><i class="layui-icon layui-icon-addition"></i> 添加文件</button>
                                                <small class="layui-upload-muted">（单个不超过50M）</small>
                                            </div>
                                    </template>
                                </layui-listfileupload>
                              </div>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label">所属品牌：</label>
                              <div class="layui-input-inline" style="width: 60%">
                                <layui-multiselect
                                    requestUniqueId="getBrandList_tmp"
                                    :single="true"
                                    ref="brandSelect"
                                    :enabled="true"
                                    name=""
                                    @selectChange="handleBrandChange"
                                    :renderText="renderBrandRow"
                                    table-name="YW_BRAND_DETAIL_V"
                                    text-field="BRAND_NAME"
                                    value-field="BRAND_ID"
                                    :show-null-option="true"
                                    :queryCondition="{}"
                                    selectFields="BRAND_ID,CLIENT_NAME,CLIENT_ID,BRAND_NAME"
                                    :enable-search="true"
                                    :sort="[]"
                                    v-model="scope.editRow.BRAND_ID"
                                  ></layui-multiselect>
                              </div>
                            </div>

                            <div class="layui-form-item" style="margin-top: 30px">
                                <label class="layui-form-label">备注：</label>
                                <div class="layui-input-inline" style="width: 60%">
                                <textarea  v-model="scope.editRow.STORAGE_REMARK" name="STORAGE_REMARK"
                                                    class="layui-textarea"></textarea>
                                </div>
                            </div>
                      </div>
                    </div>
                  </div>
              </template>
          </div>
          <div class="layui-form-btn">
              <div class="layui-footer">
                <button class="layui-btn refresh" title="关闭" @click="layer.closePop('storageForm')">
                  关 闭
                </button>
                <button class="layui-btn" title="保存" @click="$refs.storageForm.save(tableObj)">
                  保 存
                </button>
              </div>
          </div>
        </template>
      </layui-form>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      requestId: 'storageRequestId',
      form_rule: {
        STORAGE_NAME: {
          required: { message: '资料名称不能为空'},
        },
      },
      tableObj: {

      }
    }
  },
  mounted () {
    this.storageForm = this.$refs.storageForm;
  },
  methods: {
    handleBrandChange: function () {

    },
    renderBrandRow: function (row) {
      if (row) {
        return `<div>${row.BRAND_NAME}【${row.CLIENT_NAME}】</div>`
        var width = $("#manager").width() - 20 - 12 - 30;
        var content = ''
          if(row['MANAGER_PHONE']){
            content = row['MANAGER_NAME'] + "【" + row['MANAGER_PHONE'] + "】";
          } else {
            content = row['MANAGER_NAME'];
          }
          return  '<div style="white-space: nowrap;max-width:'+ width +'px;overflow: hidden;" title="'+ content +'">' + content + "</div>";

      }
      return ''
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/workOrder/storage/storageForm.vue